<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="giftModalvisible = true" type="primary" icon="md-add">添加礼包</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="800">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="活动标题" prop="name" >
          <Input v-model="form.name" style="width:100%"/>
        </FormItem>
        <FormItem label="活动详情" prop="content" >
            <Input v-model="form.content" type="textarea"/>
        </FormItem>
        <FormItem label="活动开始时间" prop="beginDate" >
          <DatePicker v-model="form.beginDate" type="datetime" placeholder="" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="活动开始时间" prop="beginDate" >
          <DatePicker v-model="form.endDate" type="datetime" placeholder="" style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="活动激励方式" prop="type" >
          <Select v-model="form.type" style="width:200px">
              <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="活动地址" prop="activityUrl" >
            <Input v-model="form.activityUrl" type="text"/>
        </FormItem>
        <FormItem label="上传banner" prop="banner" >
          <Upload :default-file-list="bannerFileList" :show-upload-list="false" :on-preview="previewUploadImage" :on-success="handleImgUpload" name="poUpload" action="/hatch/fileUpload/upload" accept=".png,.jpg,.jpeg">
            <Button icon="ios-cloud-upload-outline" style="margin-right:10px">{{form.banner ? '更换banner' : '上传banner'}}</Button>
            <span>请上传 XXX * xxxx 尺寸.jpg、png 500K以内格式图片</span>
          </Upload>
          <div style="margin-top: 20px;" v-if="form.banner">
            <img style="cursor: pointer; display: inline-block; padding: 4px; border: 1px solid #dcdee2; border-radius: 4px;" @click="previewUploadImage" title="查看banner" width="150" height="100" :src="form.banner" alt="">
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button v-if="modalTitle === '添加'" type="primary" :loading="submitLoading" @click="handleSubmit(0)">保存</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit(1)">提交</Button>
      </div>
    </Modal>
    <Modal title="添加礼包" v-model="giftModalvisible" :mask-closable='false' :width="800">
      <Form :rule="formValidate" ref="form" :model="giftForm" :label-width="100" :rules="formValidate" >
        <FormItem label="礼包名称" prop="name" >
          <Input v-model="giftForm.name" style="width:100%"/>
        </FormItem>
        <FormItem label="礼包份数" prop="servings" >
            <Input v-model="giftForm.servings" type="number"/>
        </FormItem>
        <FormItem label="礼包内容" prop="stopDate" >
          <Button style="margin-right: 10px" :key="i" v-for="(gift, i) in giftForm.activityGiftRightsList" type="default">
            {{gift.name}} x {{gift.countNumber}} &nbsp;&nbsp;
            <Icon type="ios-close-circle-outline" @click="removeGift(i)" />
          </Button>
          <Button @click="addGiftVisible = true" type="primary">添加</Button>
          
        </FormItem>
        <FormItem label="备注" prop="remarks" >
          <Input type='textarea'/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="giftModalvisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleGiftSubmit">提交</Button>
      </div>
    </Modal>
    <Modal :title="'添加礼包内容'" v-model="addGiftVisible" :mask-closable='false' :width="400">
      <Form ref="form" :model="addGiftForm" :label-width="100" :rules="formValidate" >
        <FormItem label="选择服务内容" prop="type" >
          <Select v-model="addGiftForm.code">
            <OptionGroup label="选择服务内容">
              <Option :key="gift" v-for="gift in giftBizTypeList" :value="gift.code">{{gift.name}}</Option>
            </OptionGroup>
          </Select>
        </FormItem>
        <FormItem label="设置单份次数" prop="countNumber" >
          <Input v-model="addGiftForm.countNumber" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="addGiftVisible=false">取消</Button>
        <Button type="primary" @click="addGift">提交</Button>
      </div>
    </Modal>

    <Modal width="800" title="图片预览" v-model="viewImage" :styles="{top: '30px'}" draggable>
      <img :src="viewImageUrl" alt="无效的图片链接" style="width: 100%;margin: 0 auto;display: block;" />
      <div slot="footer">
        <Button @click="viewImage=false;viewImageUrl=bannerFile.fileUrl">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// import createActivity from './createActivity'
import uploadPicInput from "@/views/my-components/hatch/upload-pic-input";
import {postRequest} from "@/libs/axios";
const STATUS = {
  '0': '草稿',
  '1': '正常',
  '2': '暂停',
}
const TYPES = {
  '1': "红点",
  '2': "落地活动",
  '5': "pc-首页",
  '6': "移动端-首页",
  '7': "移动端-营销",
}
export default {
  name: "newActivityList",
  components: {
    uploadPicInput
  },
  data() {
    return {
      TYPES,
      uploadfile: {
        name: ""
      },
      typeList: [
        {value: '1', label: TYPES['1']},
        {value: '2', label: TYPES['2']},
        {value: '5', label: TYPES['5']},
        {value: '6', label: TYPES['6']},
        {value: '7', label: TYPES['7']},
      ],
      bannerFileList: [],
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      viewImageUrl: '', // 预览图片url
      viewImage: false, // 预览图片
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      giftModalvisible: false,
      addGiftVisible: false,
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        // sort: "createDate", // 默认排序字段
        // order: "desc", // 默认排序方式
        // startDate: "", // 起始时间
        // endDate: "" // 终止时间
      },
      selectedActivity: null,
      addGiftForm: {
        code: "",
        countNumber: ""
      },
      form: { // 添加或编辑表单对象初始化数据
        name: "",
        remarks: "",
        type: "1"
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "活动名称",
          key: "name",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "活动状态",
          key: "status",
          width: 120,
          sortable: false,
          render: (h, params) => {
            return h("div" , STATUS[params.row.status] || params.row.status)
          }
        },
        {
          title: "礼包类型",
          key: "type",
          width: 120,
          sortable: false,
          render: (h, params) => {
            return h("div" , this.TYPES[params.row.type] || params.row.type)
          }
        },
        {
          title: "活动banner",
          key: "banner",
          width: 140,
          sortable: false,
          render: (h, params) => {
            return h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-eye"
                  },
                  on: {
                    click: () => {
                      this.viewImageUrl = params.row.banner;
                      this.viewImage = true;
                    }
                  }
                },
                "查看banner"
            )
          }
        },
        {
          title: "参与人数",
          key: "partakeNumber",
          width: 120,
          sortable: false,
        },
        {
          title: "截止时间",
          key: "stopDate",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            return h("div", params.row.beginDate + ' - ' + params.row.endDate)
          }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          minWidth: 200,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "md-trash"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-add"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.selectedActivity = params.row;
                      this.giftModalvisible = true;
                    }
                  }
                },
                "添加礼包"
              ),
              params.row.status === 0 && 
              h(
                "Button",
                {
                  props: {
                    type: "default",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "草稿"
              ),
              params.row.status === 2 && 
              h(
                "Button",
                {
                  props: {
                    type: "default",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.start(params.row);
                    }
                  }
                },
                "开始"
              ),
              params.row.status === 1 && 
              h(
                "Button",
                {
                  props: {
                    type: "default",
                    size: "small",
                    icon: "ios-pause"
                  },
                  on: {
                    click: () => {
                      this.stop(params.row);
                    }
                  }
                },
                "暂停"
              ),
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0, // 表单数据总数

      giftForm: { // 添加或编辑表单对象初始化数据
        name: "",
        remarks: "",
        servings: "",
        activityGiftRightsList: [],
      },
      giftBizTypeList: [],
      formValidate: {
        name: [
          { required: true, message: "活动标题不能为空", trigger: "blur" }
        ],
        detail: [
          { required: true, message: "活动详情不能为空", trigger: "blur" },
        ],
        time: [
          { required: true, message: "活动截止时间不能为空" },
        ],
        gift: [
          { required: true, message: "活动激励方式不能为空" },
        ],
      },
      bannerFile: {},
    };
  },
  methods: {
    init() {
      this.getDataList();
      this.getGiftList();
    },
    previewUploadImage(){
      this.viewImageUrl = this.form.banner;
      this.viewImage = true;
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口

      this.getRequest("/activity/getByPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      // 以下为模拟数据
      // this.data = [
      // ];
      // this.total = this.data.length;
      // this.loading = false;
    },
    addGift() {
      this.addGiftVisible = false;
      const g = this.giftBizTypeList.find(item => item.code === this.addGiftForm.code)
      this.giftForm.activityGiftRightsList.push({...g, countNumber: this.addGiftForm.countNumber})
    },
    omitForm(data){
      delete data.createBy;
      delete data.createDate;
      delete data.updateBy;
      delete data.updateDate;
      delete data.delFlag;
      delete data._index;
      delete data._rowKey;
      delete data.partakeNumber;
    },
    handleSubmit(status) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          console.log(`this.form`, this.form)
          Object.assign(this.form, {status})
          let postData = Object.assign({}, this.form, {
            beginDate: this.form.beginDate ? this.fmtDate("yyyy-MM-dd", this.form.beginDate) : '',
            endDate: this.form.endDate ? this.fmtDate("yyyy-MM-dd", this.form.endDate): ''
          });
          console.log(`this.form2`, this.form)
          this.omitForm(postData);
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;

            this.postRequest("/activity/insertOrUpdate", postData).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            // this.submitLoading = false;
            // this.$Message.success("操作成功");
            // this.getDataList();
            // this.modalVisible = false;
          } else {
            // 编辑
            this.postRequest("/activity/insertOrUpdate", postData).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            // this.submitLoading = false;
            // this.$Message.success("操作成功");
            // this.getDataList();
            // this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      console.log(v)
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          this.deleteRequest("/activity/delByIds/" + v.id).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.getDataList();
            }
          });
          // 模拟请求成功
          // this.$Message.success("操作成功");
          // this.$Modal.remove();
          // this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          this.deleteRequest("/activity/delByIds/" + ids).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getDataList();
            }
          });
          // 模拟请求成功
          // this.$Message.success("操作成功");
          // this.$Modal.remove();
          // this.clearSelectAll();
          // this.getDataList();
        }
      });
    },
    stop(item) {
      const id = item.id;
      // this.handleSubmit(2);

      this.postRequest("/activity/insertOrUpdate", {id: id, status: 2}).then(res => {
        this.submitLoading = false;
        if (res.success) {
          this.$Message.success("操作成功");
          this.getDataList();
          this.modalVisible = false;
        }
      });
    },
    start(item) {
      const id = item.id;
      this.postRequest("/activity/insertOrUpdate", {id: id, status: 1}).then(res => {
        this.submitLoading = false;
        if (res.success) {
          this.$Message.success("操作成功");
          this.getDataList();
          this.modalVisible = false;
        }
      });
    },
    getGiftList() {
      //GET /hatch/activityGift/getGiftBizTypeList
      this.getRequest("/activityGift/getGiftBizTypeList").then(res => {
        console.log(res)
        this.giftBizTypeList = res.result;
      });
    },
    handleGiftSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // data.activityGiftRightsList = JSON.stringify(this.form.activityGiftRightsList)
          const activityGift = {
            name: this.giftForm.name,
            remarks: this.giftForm.remarks,
            servings: this.giftForm.servings,
            activityId: this.selectedActivity.id,
            activationStatus: 0
          }
          const rightsList = this.giftForm.activityGiftRightsList.map(item => {
            return {
              type: item.code,
              countNumber: item.countNumber
            }
          })
          // this.giftForm.activityGiftRightsList.forEach((item, i) => {
          //   data[`activityGiftRightsList[${i}].type`] = item.code;
          //   data[`activityGiftRightsList[${i}].countNumber`] = item.countNumber;
          // })
          const data = {
            activityGift,
            rightsList
          }
          this.postRequestJson("/activityGift/insertOrUpdate", data).then(res => {
            this.submitLoading = false;
            if (res.success) {
              this.$Message.success("操作成功");
              this.getDataList();
              this.giftModalvisible = false;
            }
          }).catch(e => console.error(e));
        }
      });
    },
    removeGift(index) {
      this.addGiftForm.activityGiftRightsList = this.addGiftForm.activityGiftRightsList.filter((_, i) => index !== i);
    },
    handleImgUpload(res, file, fileList) {
      this.bannerFile = res;
      this.form = {...this.form, banner: res.fileUrl}
      console.log(res)
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
}
</style>